import { useEffect, useState } from "react";
import usePagination from "../usePagination";
import { fetchAdminCourses } from "../../service/AdminService/courseService";
import { message } from "antd";

export const useAdminCourseData = (status, search) => {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const isActive = status === "active";

  const {
    currentPage,
    pageSize,
    setTotal,
    paginationConfig,
    handlePageChange,
  } = usePagination(0, 10);

  const getAllCourses = async () => {
    setLoading(true);

    const response = await fetchAdminCourses({
      page: currentPage,
      pageSize,
      search,
      active: isActive,
    });

    if (response.success) {
      setData(response?.data?.data?.content);
      setTotal(response?.data?.data?.totalElements);
    } else {
      message.error(response.message);
    }
    setLoading(false);
  };

  useEffect(() => {
    getAllCourses();
  }, [currentPage, pageSize, status, search]);

  

  return {
    data,
    loading,
    paginationConfig,
    handlePageChange,
    refreshData: getAllCourses,
  };
};
